'use client'
import Image from 'next/image'
import React, { useState } from 'react'
import { motion } from 'framer-motion'
const AccordionLayout = ({
  isExpanded,
  onToggle,
  index = 0,
  title,
  content,
  priveFaq = false,
}) => {
  // const [isExpandedIndex, setIsExpandedIndex] = useState(null)
  const handleToggleAccordion = (index) => {
    // setIsExpandedIndex(isExpandedIndex === index ? null : index)
    onToggle(index)
  }
  return (
    <div
      className={`leading-[1.5] ${
        priveFaq ? 'text-[16px]' : 'text-[18px]'
      } md:text-[16px]`}
    >
      <div
        onClick={() => handleToggleAccordion(index)}
        className={`py-5 cursor-pointer ${
          !isExpanded ? 'hover:bg-[#f5f5f5]' : ''
        } border-t border-[rgba(139,149,158,.5019607843)]  duration-300 ease-in-out transition-colors flex items-center justify-between`}
      >
        <p className='font-light mr-4 sm:mr-0'>{title}</p>
        {isExpanded ? (
          <div className='mr-4 flex-shrink-0'>
            <Image
              src='/images/accordion-arrow-up.svg'
              alt=''
              width={24}
              height={24}
              className='w-6 h-6'
            />
          </div>
        ) : (
          <div className='mr-4 flex-shrink-0'>
            <Image
              src='/images/accordion-arrow-down.svg'
              alt=''
              width={24}
              height={24}
              className='w-6 h-6'
            />
          </div>
        )}
      </div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{
          height: isExpanded ? 'auto' : 0,
          opacity: isExpanded ? 1 : 0,
        }}
        transition={{ duration: 0.2 }}
        className={`overflow-hidden`}
      >
        <div className='mb-5 font-light leading-[25px] text-[16px]'>{content}</div>
      </motion.div>
    </div>
  )
}

export default AccordionLayout
